import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  setCurrentAuthenticatedUserFulfilled,
  setCurrentAuthenticatedUserPending,
  updateCurrentAuthenticatedUser
} from '@futrli/auth/auth/redux-utils/actions';
import { appAuthenticator, checkCurrentUser } from '@futrli/shared-services';

export const useRefreshCurrentUser = () => {
  const dispatch = useDispatch();

  const refreshCurrentUser = useCallback(
    async (quiet = false) => {
      // Get updated user data from backend
      const newCurrentUser = await checkCurrentUser();

      // Set loading flag in redux if quiet = false
      if (!quiet) {
        dispatch(setCurrentAuthenticatedUserPending());
      }

      // Get merged user data (merges API data with data from auth system, e.g: Auth0)
      const user = await appAuthenticator.getCurrentAuthenticatedUser(newCurrentUser);

      // Update redux with newest merged user data
      if (quiet) {
        dispatch(updateCurrentAuthenticatedUser(user));
      } else {
        dispatch(setCurrentAuthenticatedUserFulfilled(user));
      }
    },
    [dispatch]
  );

  return {
    refreshCurrentUser
  };
};
